import { Component, OnInit, TemplateRef, ViewChild } from '@angular/core';
import { Input } from '@angular/core';
import { CustomItemContext } from 'app/components/data-table/data-table.component';

@Component({
  selector: 'referral-traffic-section',
  templateUrl: './referral-traffic-section.html',
  styleUrls: ['./referral-traffic.css']
})
export class ReferralTrafficSection implements OnInit {
  @Input() trafficData: Object;
  @Input() region;
  @Input() device;

  @ViewChild('domainTemplate', { static: true })
  domainTemplate: TemplateRef<CustomItemContext>;

  pageReferrers = [];
  headers = [];

  constructor() {}

  ngOnInit() {
    const pageReferrers = this.trafficData['pageReferrers'];

    this.headers.push({
      class: 'col-4',
      text: 'DOMAIN NAME',
      key: 'pageReferrers'
    });
    this.headers.push({
      class: 'col',
      text: '',
      format: 'percent',
      key: 'totalTrafficRatio'
    });
    this.headers.push({
      class: 'col',
      text: '',
      format: 'percent',
      key: 'givtSivtRate'
    });
    this.headers.push({
      class: 'col',
      text: '',
      format: 'percent',
      key: 'nonGivtSivtViewability'
    });

    for (let referrer of pageReferrers) {
      let domain = referrer['pageReferrers'];
      referrer['pageReferrersTemplate'] = this.domainTemplate;
      referrer['pageReferrersRouterLink'] = [
        '/insight/domains',
        domain,
        this.region,
        this.device
      ];
    }

    this.pageReferrers = pageReferrers;
  }
}
